import { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'components/UI/Modal/Modal';
import { CloseButton } from 'components/UI/CloseButton/CloseButton';
import { EventFiltersCheckboxes } from '../EventFiltersCheckboxes/EventFiltersCheckboxes';
import { EventFilterModalControls } from '../EventFiltersModalControls/EventFilterModalControls';
import { EventFiltersContext } from '../../../Shared/EventFiltersProvider';
import './EventFiltersModal.scss';

export const EventFiltersModal = (props) => {
  const {
    filterSet,
    modalIsOpen,
    closeModalHandler,
    eventFilters,
    setEventFilters = () => {},
  } = props;
  const [applyFiltersButtonDisabled, setApplyFiltersButtonDisabled] = useState(true);
  const { appliedFilters, setAppliedFilters } = useContext(EventFiltersContext);

  useEffect(() => {
    setApplyFiltersButtonDisabled(true);
  }, [modalIsOpen]);

  const applyFiltersButtonHandler = () => {
    setAppliedFilters(eventFilters);
    setApplyFiltersButtonDisabled(true);
    closeModalHandler();
  };

  const clearAllFiltersHandler = () => {
    setEventFilters([]);
    setAppliedFilters([]);
    setApplyFiltersButtonDisabled(true);
    closeModalHandler();
  };

  const dropdownUpdateHandler = (selectedCheckboxes) => {
    if (Object.keys(selectedCheckboxes).length <= 0) {
      return;
    }

    if (selectedCheckboxes.SelectedOptions.length > 0) {
      /**
       * If dropdown ID exists, replace it with newly selected checkboxes,
       * retaining the old index
       */
      const existingFilterIndex = eventFilters.findIndex(
        (filter) => filter.FilterId === selectedCheckboxes.FilterId
      );
      if (existingFilterIndex >= 0) {
        eventFilters.splice(existingFilterIndex, 1, selectedCheckboxes);
      } else {
        setEventFilters((prevFilters) => [...prevFilters, selectedCheckboxes]);
      }
    } else {
      // Just remove the existing filter
      const newFilters = eventFilters.filter(
        (item) => item.FilterId !== selectedCheckboxes.FilterId
      );
      setEventFilters(newFilters);
    }
  };

  return (
    <Modal
      extendClass="event-filters-modal"
      open={modalIsOpen}
      closeModalHandler={closeModalHandler}
    >
      <CloseButton
        text="Close"
        extendClass="event-filters-modal__btn-close hidden-xs"
        onClick={closeModalHandler}
      />

      <div className="event-filters-modal__filters container modal-filters">
        <EventFiltersCheckboxes
          filterSet={filterSet}
          dropdownUpdateHandler={dropdownUpdateHandler}
          setApplyFiltersButtonDisabled={setApplyFiltersButtonDisabled}
          appliedFilters={appliedFilters}
        />
      </div>

      <EventFilterModalControls
        eventFilters={eventFilters}
        closeModalHandler={closeModalHandler}
        clearAllFiltersHandler={clearAllFiltersHandler}
        applyFiltersButtonDisabled={applyFiltersButtonDisabled}
        applyFiltersButtonHandler={applyFiltersButtonHandler}
        disabled={!eventFilters.length}
      />
    </Modal>
  );
};

EventFiltersModal.propTypes = {
  filterSet: PropTypes.array,
  modalIsOpen: PropTypes.bool,
  closeModalHandler: PropTypes.func,
  eventFilters: PropTypes.array,
  setEventFilters: PropTypes.func,
};
